import * as React from "react";
import { Button, Form, Modal } from "react-bootstrap";
import { Goal } from "src/database/types";
import { useBackButton } from "src/hooks/useBackButton";
import { upsertGoal, UpsertGoalType } from "src/database/queries/goals";

interface Props {
  goal?: Goal;
  onSave(): void;
  onCancel(): void;
}

export function GoalForm({ goal: initialGoal, onSave, onCancel }: Props) {
  const [goal, setGoal] = React.useState<UpsertGoalType>(
    initialGoal ?? {
      type: "goal",
      name: "",
    },
  );
  useBackButton(onCancel);
  const setField = <K extends keyof UpsertGoalType>(key: K, value: UpsertGoalType[K]) => {
    setGoal({ ...goal, [key]: value });
  };

  const onSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    await upsertGoal(goal);
    onSave();
  };

  return (
    <Modal show onHide={onCancel} data-testid="goal-form">
      <Form onSubmit={onSubmit}>
        <Modal.Body>
          <Form.Group className="mb-3">
            <Form.Label htmlFor="goal-form-name">Name</Form.Label>
            <Form.Control
              id="goal-form-name"
              data-testid="goal-form-name"
              autoFocus
              value={goal.name ?? ""}
              onChange={(e) => setField("name", e.target.value)}
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button type="submit" onClick={onSubmit}>
            Save Goal
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
}
